import { render, staticRenderFns } from "./ExistedProductDetails.vue?vue&type=template&id=308f663a&scoped=true"
import script from "./ExistedProductDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExistedProductDetails.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ExistedProductDetails.vue?vue&type=style&index=0&id=308f663a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308f663a",
  null
  
)

export default component.exports